'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/card/style/css');

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _user_bio = require('../components/user_bio');

var _user_bio2 = _interopRequireDefault(_user_bio);

var _user_edit = require('../components/user_edit');

var _user_edit2 = _interopRequireDefault(_user_edit);

var _user_finance = require('../components/user_finance');

var _user_finance2 = _interopRequireDefault(_user_finance);

var _user_address = require('../components/user_address');

var _user_address2 = _interopRequireDefault(_user_address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Order = _react2.default.createClass({
    displayName: 'Order',
    render: function render() {
        var _props = this.props,
            users = _props.users,
            params = _props.params;

        var user = users.filter(function (o) {
            return o.id == params.userID;
        })[0];
        var extra = _react2.default.createElement(_user_edit2.default, { user: user });
        return _react2.default.createElement(
            'div',
            { id: 'user' },
            _react2.default.createElement(
                _card2.default,
                { title: '\u57FA\u672C\u4FE1\u606F', className: 'user-card', extra: extra },
                _react2.default.createElement(_user_bio2.default, user)
            ),
            _react2.default.createElement(
                _card2.default,
                { title: '\u8D22\u52A1\u4FE1\u606F', className: 'user-card' },
                _react2.default.createElement(_user_finance2.default, { user: user })
            ),
            _react2.default.createElement(
                _card2.default,
                { title: '\u5730\u5740\u4FE1\u606F', className: 'user-card' },
                _react2.default.createElement(_user_address2.default, { addresses: user.addresses })
            )
        );
    }
}); /**
     * 用户详情页
     */


var mapStateToProps = function mapStateToProps(store) {
    var users = store.user.users;

    return {
        users: users.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Order);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/user.js
// module id = 1325
// module chunks = 0